import { activateDrawer, lockScroll, unlockScroll, bindDrawerEscape } from '@theme/coco-utilities';

function getSizeChartDrawer(drawerId) {
  return document.getElementById(drawerId);
}

class SizeChartDrawer extends HTMLElement {
  constructor() {
    super();
    this.activeElement = null;
    this.releaseModal = null;
    this.unbindEscape = null;
    this.onClick = this.onClick.bind(this);
  }

  connectedCallback() {
    this.addEventListener('click', this.onClick);
    this.unbindEscape = bindDrawerEscape(this, () => this.close());
    this.moveToBody();
    this.bindTriggers();
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
    this.unbindEscape?.();
    this.unbindEscape = null;
    this.releaseModal?.();
    this.releaseModal = null;
  }

  moveToBody() {
    if (this.parentElement === document.body) return;
    document.body.appendChild(this);
  }

  onClick(event) {
    if (!this.hasAttribute('active')) return;

    const inner = this.querySelector('[data-drawer-inner]');
    const isInsidePanel = inner?.contains(event.target);

    if (event.target.closest('[data-size-chart-close], [is="close-drawer"]')) {
      event.preventDefault();
      this.close();
      return;
    }

    if (!isInsidePanel) {
      event.preventDefault();
      this.close();
    }
  }

  bindTriggers() {
    document.querySelectorAll(`[data-size-chart-open][aria-controls="${this.id}"]`).forEach((button) => {
      if (button.dataset.sizeChartBound) return;
      button.dataset.sizeChartBound = 'true';
      button.setAttribute('aria-haspopup', 'dialog');
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.activeElement = triggeredBy;

    this.setAttribute('open', '');
    requestAnimationFrame(() => this.setAttribute('active', ''));
    lockScroll();

    if (triggeredBy) triggeredBy.setAttribute('aria-expanded', 'true');

    this.releaseModal?.();
    this.releaseModal = activateDrawer(this, {
      initialFocus: (drawer) =>
        drawer.querySelector('[data-size-chart-close]:not([data-fixed-overlay]), [is="close-drawer"]:not([data-fixed-overlay])'),
    });
  }

  close() {
    if (!this.hasAttribute('active') && !this.hasAttribute('open')) return;

    this.removeAttribute('active');

    const trigger =
      this.activeElement?.isConnected
        ? this.activeElement
        : document.querySelector(`[data-size-chart-open][aria-controls="${this.id}"]`);
    trigger?.setAttribute?.('aria-expanded', 'false');

    this.releaseModal?.(trigger);
    this.releaseModal = null;
    this.activeElement = null;

    let finished = false;
    const finish = () => {
      if (finished) return;
      finished = true;
      this.removeAttribute('open');
      unlockScroll();
    };

    const inner = this.querySelector('[data-drawer-inner]');
    if (inner) {
      const onTransitionEnd = (event) => {
        if (event.target !== inner || event.propertyName !== 'transform') return;
        finish();
      };
      inner.addEventListener('transitionend', onTransitionEnd);
    }

    setTimeout(finish, 650);
  }
}

function handleDocumentClick(event) {
  const openTrigger = event.target.closest('[data-size-chart-open]');
  if (!openTrigger) return;

  const drawerId = openTrigger.getAttribute('aria-controls');
  if (!drawerId) return;

  event.preventDefault();
  getSizeChartDrawer(drawerId)?.open(openTrigger);
}

if (!customElements.get('size-chart-drawer')) {
  customElements.define('size-chart-drawer', SizeChartDrawer);
  document.addEventListener('click', handleDocumentClick);
}
